export const Constants = {
    TAX_YEAR: 2019,
    DS_DELIMITER: '_idx_'
};